import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './PetsyExpiredPopup.scss';
import { IPetsyExpiredPopupProps } from './PetsyExpiredPopup.types';

export default function PetsyExpiredPopup(props: IPetsyExpiredPopupProps) {
  const [enableButton, setEnableButton] = React.useState<boolean>(true);
  const [renderKey, setRenderKey] = React.useState(0);
  const navigate = useNavigate();

  function modalClose() {
    setEnableButton(false);
  }

  const optionRef = React.useRef<any>();
  function submit() {
    modalClose();
    props.onClose();
    // console.log("props.sessionData", props.sessionData);
    navigate(props.sessionData['quote-slug'] || '');
  }

  return (
    <>
      <Modal
        className='flc_petsy-expired-popup'
        show={props.show}
        onHide={modalClose}
        backdrop='static'
        keyboard={false}
        fullscreen='sm-down'
        centered
      >
        <Modal.Body className='text-center' ref={optionRef}>
          Hi Pet Lover, Your old quote has expired and we have created a new
          quote using the previously provided details.
        </Modal.Body>
        <div className=''>
          <Button
            key={renderKey}
            disabled={false}
            className={
              'flc_next-button btn mt-3 py-3 mt-4 btn-' +
              (enableButton ? 'primary' : 'secondary ')
            }
            onClick={submit}
          >
            See my new quote
          </Button>
        </div>
      </Modal>
    </>
  );
}
